import { postMethod } from '@/views/regenerateAuth.js'
import { getAuth } from '../../../../../service.js'
import axios from 'axios'
// const apiBaseURL = "http://localhost:4000"+'/api/v1/';

const apiBaseURL = process.env.VUE_APP_EMAIL_SENT_API+'/api/v1/';


export async function revertBookingTimeOfTutorInTimeSlotCollection(requestOptions, cb) {
    if (!localStorage.getItem('jwtToken')) {
        getAuth('', async (auth) => {
            if (auth && auth.success && auth.token) {
                localStorage.setItem('jwtToken', auth.token);
                axios.post(apiBaseURL+'revertBookingTimeOfTutorInTimeSlotCollection', requestOptions, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
                    }
                }).then(result => {
                    if (result.data.success === false) {
                        postMethod('revertBookingTimeOfTutorInTimeSlotCollection', requestOptions, '', (resData) => {
                            cb(resData);
                        });
                        return;
                    }
                    cb(result.data);
                }).catch(error => {
                    console.error(error);
                    cb({
                        status:false,
                        errorMessage: error
                    });
                });
            }
        });
    } else {
        axios.post(apiBaseURL+'revertBookingTimeOfTutorInTimeSlotCollection', requestOptions, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
                
            }
        }).then(result => {
            if (result.data.success === false) {
                postMethod('revertBookingTimeOfTutorInTimeSlotCollection', requestOptions, '', (resData) => {
                    cb(resData);
                });
                return;
            }
            cb(result.data);
        }).catch(error => {
            console.error(error);
            cb({
                status:false,
                errorMessage: error
            });
        });
    }
};
